import React from 'react';
import { Box } from '@mui/material';
import StatContainer from '../../../components/insights/stats/StatContainer';

const TeamStatsGrid = ({ stats, activeTeamMembersCount = 0 }) => {
    // Get contactsDownloaded value with fallbacks
    const contactsDownloadedValue =
        (stats.contactsDownloaded && typeof stats.contactsDownloaded === 'object' && stats.contactsDownloaded.value !== undefined)
            ? stats.contactsDownloaded.value
            : (typeof stats.contactsDownloaded === 'number')
                ? stats.contactsDownloaded
                : 0;

    // Get percentage with fallbacks  
    const contactsDownloadedPercentage =
        (stats.contactsDownloaded && typeof stats.contactsDownloaded === 'object' && stats.contactsDownloaded.percentage !== undefined)
            ? stats.contactsDownloaded.percentage
            : 0;

    // Get trend with fallbacks
    const contactsDownloadedTrend =
        (stats.contactsDownloaded && typeof stats.contactsDownloaded === 'object' && stats.contactsDownloaded.trend)
            ? stats.contactsDownloaded.trend
            : 'neutral';

    // Team stats array - matching individual plan structure but with Active Team Members instead of Link Taps
    const teamStats = [
        {
            title: 'Leads',
            value: typeof stats.leadsGenerated === 'object' ? stats.leadsGenerated.value : (stats.leadsGenerated || 0),
            percentage: typeof stats.leadsGenerated === 'object' ? stats.leadsGenerated.percentage : 0,
            trend: typeof stats.leadsGenerated === 'object' ? stats.leadsGenerated.trend : 'up',
            info: 'Total number of leads generated by all team members in the selected time period'
        },
        {
            title: 'Views',
            value: typeof stats.cardViews === 'object' ? stats.cardViews.value : (stats.cardViews || 0),
            percentage: typeof stats.cardViews === 'object' ? stats.cardViews.percentage : 0,
            trend: typeof stats.cardViews === 'object' ? stats.cardViews.trend : 'up',
            info: 'Total number of times team member cards were viewed'
        },
        {
            title: 'Contacts Downloaded',
            value: contactsDownloadedValue,
            percentage: contactsDownloadedPercentage,
            trend: contactsDownloadedTrend,
            info: 'Total number of times team member contacts were downloaded'
        },
        {
            title: 'Active Team Members',
            value: activeTeamMembersCount,
            percentage: 0,
            trend: 'neutral',
            info: 'Number of active team members in the team'
        }
    ];

    return (
        <Box
            sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px'
            }}
        >
            {teamStats.map((stat, index) => (
                <StatContainer key={index} {...stat} hidePercentage={true} />
            ))}
        </Box>
    );
};

export default TeamStatsGrid;

